export const t = {
  sand:    '#F5EFE6',
  warm:    '#EDE3D6',
  clay:    '#C8956C',
  clayD:   '#A67352',
  teal:    '#2E7D6B',
  tealL:   '#4A9E89',
  tealBg:  'rgba(46,125,107,0.08)',
  slate:   '#3D4F5C',
  slateL:  '#5A6F7D',
  text:    '#2C2C2C',
  textL:   '#5C5C5C',
  white:   '#FFFFFF',
  shadow:  '0 2px 16px rgba(60,50,40,0.10)',
  border:  '1px solid rgba(200,149,108,0.18)',
  fonts: {
    display: "'Playfair Display', serif",
    body:    "'Inter', sans-serif",
  },
};
